// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-background-colour: #333333;
  --footer-link-colour: #fff;
  --nav-bar-background-colour: #fff;
  --product-content-padding: 0 10px;
}

:host {
  overflow: auto;
}

.menu {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.menu-loading {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: -130px;
}

.app-display-group-card-component {
  display: flex;
}

.menu-content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
.menu-content-products {
  display: flex;
  flex-direction: column;
}
.menu-content-products-announcement {
  max-width: 100%;
  padding: 15px;
  text-align: center;
}
.menu-content-products-allergens {
  color: #E3000E;
  max-width: 100%;
  padding: 15px;
  text-align: center;
}
.menu-content .category {
  align-items: center;
  display: flex;
  flex-direction: column;
  scroll-margin-top: 45px;
}
.menu-content .category-item {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 0 25px 1px rgba(53, 53, 53, 0.25);
  margin: 0 15px 35px;
  max-width: 350px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.menu-content .category-item-list {
  display: flex;
  flex-direction: column;
  width: 1140px;
}
.menu-content .category-item-list-items {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.menu-content .category-name {
  font-family: Tenant-Bold, Courier, Helvetica, sans-serif;
  font-size: 20px;
}

.menu-header {
  background-color: #dbdfe6;
  width: 100%;
}
.menu-header-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.menu-header-content-item {
  padding: 10px 5px 0;
  display: flex;
  align-items: baseline;
}
.menu-header-content-item-link.search {
  padding: 12px;
  border-radius: 50%;
  margin-bottom: 0 !important;
  margin-top: 4px;
}
.menu-header-content-item-link.search-input {
  border: none;
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
  height: 36px;
  padding: 0 0 0 10px;
  transition: 0.3s ease-in-out;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.menu-header-content-item-link.search-input::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

.menu-header-content-item-link.icon {
  align-items: center;
  border: none;
  display: flex;
  height: 22px;
  justify-content: center;
  width: 22px;
}
.menu-header-content-item-link.icon.search {
  padding: 15px;
  border-radius: 50%;
  background-color: #443635;
  color: #fff;
  font-size: 20px;
  margin-top: 0;
}
.menu-header-content-item-link.icon.close {
  opacity: 0.5;
  font-size: 18px;
}
.menu-header-content-item-link.icon.close:hover {
  opacity: 0.8;
}

.menu-header-content-item:last-of-type {
  padding-bottom: 10px;
}

.input-group {
  display: none;
  transition: 0.7s ease-in-out;
}
.input-group-text {
  align-items: center;
  background-color: #fff;
  border: none;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  cursor: pointer;
  display: flex;
  height: 36px;
  padding-left: 0;
  padding-right: 4px;
}

.input-group-append:last-of-type .input-group-text {
  border-bottom-right-radius: 16px;
  border-top-right-radius: 16px;
}

.expanded {
  align-items: center;
  border-radius: 12px !important;
  display: flex;
  flex-direction: row;
  margin-top: 0 !important;
  padding: 9px !important;
}
.expanded-input {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  transition: 0.7s ease-in-out;
}
.expanded-icon {
  display: none !important;
}

.input-group.mb-3 {
  margin-bottom: 0 !important;
}

div#search-results-target {
  padding: 10px;
}

.sort {
  display: flex;
  justify-content: center;
  text-align: end;
}
.sort-header {
  width: 1140px;
  padding: 0 0.5%;
}
.sort-header-text {
  cursor: pointer;
  float: right;
  padding: 5px;
  text-align: end;
  width: 150px;
}
.sort-cards {
  background-color: #fff;
  box-shadow: 0 2px 8px 2px rgba(0, 0, 0, 0.175);
  border: thin solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  cursor: pointer;
  margin: 0px 0 0 20px;
  padding: 10px 15px;
}
.sort-cards-ul {
  list-style-type: none;
  margin-bottom: 0;
  padding: 0;
}
.sort-cards-li {
  margin-bottom: 8px;
}
.sort-cards-li:last-of-type {
  margin-bottom: 0;
}
.sort-cards-li:hover {
  box-shadow: 0 2px 2px -2px #E3000E;
}

.menu-page-footer {
  height: 35px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-page-footer-branding {
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #000045;
  padding-left: 4px;
  cursor: pointer;
}
.menu-page-footer-branding-img {
  max-height: 46px;
  margin-left: -13px;
  margin-bottom: 3px;
}
.menu-page-footer-branding-text {
  font-size: 12px;
  font-weight: 600;
}
.menu-page-footer-legal-links {
  height: 100%;
  display: flex;
  align-items: center;
}
.menu-page-footer-legal-links-item {
  margin-bottom: 0 !important;
  font-size: 13px;
  margin-top: -1px;
  cursor: pointer;
  color: #000045;
  padding: 0 3px;
}
.menu-page-footer-legal-links-item:hover {
  text-decoration: underline;
}

.category-item-list div {
  display: flex;
}

.websection-header-group {
  margin: 10px 16px;
  color: #fff;
  background-color: #424858;
  align-items: center;
  padding: 10px;
}
.websection-header-group div {
  display: flex;
  flex-direction: column;
}
.websection-header-group h1 {
  margin-bottom: 0;
}
.websection-header-group img {
  max-width: 125px;
  margin-right: 10px;
}

.order-wanted-details {
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-header.sticky {
  top: 0;
}

.basket-footer.button-action-1.sticky {
  bottom: 0;
  z-index: 2;
  height: 45px;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 0;
  width: 100%;
  border-top: thin solid #fff;
}
.basket-footer.button-action-1.sticky span {
  flex: 1;
  text-transform: uppercase;
  text-align: center;
}
.basket-footer.button-action-1.sticky div {
  display: flex;
  margin: 0 10px;
}
.basket-footer.button-action-1.sticky samp {
  margin: 0 5px;
}

.order-wanted-details .wanted-time-change-button {
  margin-left: 5px;
}

.order-wanted-details .basket-delivery-time-icon {
  border-radius: 12px;
}

.order-wanted-details span:nth-child(2) {
  margin-left: 4px;
}

@media screen and (max-width: 1023px) {
  .menu-card-image {
    min-height: 185px;
    min-width: 328px;
  }
  .menu-header {
    min-height: 69px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
  }
  .menu-header-content {
    white-space: nowrap;
    flex-wrap: nowrap;
    justify-content: unset;
    max-height: 100%;
  }
  .menu-header-content-item {
    margin: 10px 2px;
    padding: 0 3px;
  }
}
@media screen and (max-width: 479px) {
  .menu-header {
    height: 45px;
    min-height: 45px;
  }
  .menu-header-content-item {
    margin: 0 2px;
  }
  .menu-header-content-item .button-menu-cat {
    padding: 8px 30px;
  }
  .menu-header-content-item-link.search.button-menu-cat {
    padding: 6px;
  }
  .menu-header-content-item-link.search.button-menu-cat.disable-select.expanded {
    padding: 3px 5px !important;
  }
  .menu-card.category-item {
    margin: 0 10px 20px !important;
  }
  .menu-content {
    overflow-y: unset;
    padding-bottom: 45px;
  }
  .menu-content .category-item-list {
    justify-content: center;
  }
  .menu-content-products-allergens {
    padding-bottom: 0;
    text-align: center;
  }
  p:last-of-type {
    margin-bottom: 0;
  }
  .menu-page-footer {
    font-size: 12px;
  }
  .websection-header-group {
    margin: 5px 10px 2px;
    padding: 5px;
  }
  .websection-header-group img {
    width: 85px;
    margin-right: 5px;
  }
  .websection-header-group h2 {
    margin-bottom: 4px;
    font-size: 16px;
  }
  .websection-header-group span {
    font-size: 13px;
  }
  .app-display-group-card-component {
    width: 100%;
    max-width: calc(50% - 5px);
    box-sizing: border-box;
  }
  .category-item-list-items {
    justify-content: center;
  }
}
@media screen and (max-width: 479px) and (max-width: 340px) {
  .menu-card.category-item {
    width: 97%;
  }
  .menu-card-image {
    min-width: unset;
    min-height: 185px;
  }
}
@media screen and (max-width: 1140px) {
  .sort-header, .menu-content .category-item-list {
    width: 760px;
  }
}
@media screen and (max-width: 760px) {
  .menu-content .category-item-list {
    justify-content: center;
    width: 100%;
  }
  .sort {
    justify-content: flex-end;
  }
  .sort-cards {
    margin: 0;
  }
  .sort-header {
    padding-right: 2%;
    width: unset;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
